import axios from 'axios';

export default (config) => {
  const instance = axios.create(config);

  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line global-require
    const mockApi = require('../../../mockApi/dev');
    mockApi.setup(instance);
  }
  return instance;
};
